<template>
	<div>
		<nav class="navbar navbar-expand-md navbar-light bg-white shadow-sm">
            <div class="container">
                <a class="navbar-brand" href="/">
                    Mimo & Ponto .
                </a>
                <button 
                	class="navbar-toggler" 
                	type="button" 
                	data-toggle="collapse" 
                	data-target="#navbarSupportedContent" 
                	aria-controls="navbarSupportedContent" 
                	aria-expanded="false" 
                	aria-label="'Toggle navigation'">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <!-- Left Side Of Navbar -->
                    <ul class="navbar-nav mr-auto">
                        
                    </ul>

                    <ul class="navbar-nav ml-auto" v-if="$auth.session">
                        <li class="nav-item dropdown">
                            <a 
                            	id="navbarDropdown" 
                            	class="nav-link dropdown-toggle" 
                            	href="#" 
                            	role="button" 
                            	data-toggle="dropdown" 
                            	aria-haspopup="true" 
                            	aria-expanded="false">
                                	{{ $auth.user.name }}
                                	<span class="caret"></span>
                            </a>
                            <div 
                            	class="dropdown-menu dropdown-menu-right" 
                            	aria-labelledby="navbarDropdown">
                                <button 
                                	class="dropdown-item"
                                    @click="logout()">
                                    Sair
                                </button>
                            </div>
                        </li>
                    </ul>
                    <ul class="navbar-nav ml-auto" v-else>
                        <li class="nav-item">
                            <a class="nav-link" href="login">Login</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="register">Cadastro</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <main class="py-4">
            <slot></slot>
        </main>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				//
			}
		},
		methods: {
			logout(){
				axios.post(this.$url+'/logout');
                window.location.href = this.$url+'/welcome';
			}
		}
	}
</script>